import {CommonModule}                         from '@angular/common';
import {HttpClientModule}                     from '@angular/common/http';
import {NgModule}                             from '@angular/core';
import {FormsModule, ReactiveFormsModule}     from '@angular/forms';
import {MatAutocompleteModule}                from '@angular/material/autocomplete';
import {MatButtonModule}                      from '@angular/material/button';
import {MatCardModule}                        from '@angular/material/card';
import {MatChipsModule}                       from '@angular/material/chips';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDialogModule}                      from '@angular/material/dialog';
import {MatDividerModule}                     from '@angular/material/divider';
import {MatFormFieldModule}                   from '@angular/material/form-field';
import {MatGridListModule}                    from '@angular/material/grid-list';
import {MatIconModule}                        from '@angular/material/icon';
import {MatInputModule}                       from '@angular/material/input';
import {MatMenuModule}                        from '@angular/material/menu';
import {MatSelectModule}                      from '@angular/material/select';
import {MatSlideToggleModule}                 from '@angular/material/slide-toggle';
import {MatTableModule}                       from '@angular/material/table';
import {MatTabsModule}                        from '@angular/material/tabs';
import {MatCheckboxModule}                    from '@angular/material/checkbox';
import {MatToolbarModule}                     from '@angular/material/toolbar';
import {LeafletModule}                        from '@asymmetrik/ngx-leaflet';
import {SweetAlert2Module}                    from '@sweetalert2/ngx-sweetalert2';
import {NgxChartsModule}                      from '@swimlane/ngx-charts';
import {ToastrModule}                         from 'ngx-toastr';
import {BreadcrumbModule}                     from 'xng-breadcrumb';

@NgModule({
    imports: [
        CommonModule,
        ToastrModule.forRoot(),
        SweetAlert2Module.forRoot({
            provideSwal: () => import('sweetalert2/dist/sweetalert2.js')
                .then(({default: swal}) => swal.mixin({
                    confirmButtonText: 'Ok',
                    showCancelButton: true,
                    cancelButtonText: 'Cancel',
                    focusCancel: true,
                    reverseButtons: true,
                }))
        }),
    ],
    declarations: [],
    exports: [
        CommonModule,
        BreadcrumbModule,
        FormsModule,
        HttpClientModule,
        MatButtonModule,
        MatNativeDateModule,
        MatRippleModule,
        MatFormFieldModule,
        MatIconModule,
        MatToolbarModule,
        MatInputModule,
        MatSlideToggleModule,
        MatCardModule,
        MatDividerModule,
        MatTabsModule,
        MatTableModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatGridListModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatDialogModule,
        LeafletModule,
        NgxChartsModule,
        ToastrModule,
        SweetAlert2Module,
        MatCheckboxModule
    ],
})
export class SharedModule
{
}
